module.exports = __webpack_public_path__ + "static/featured-in-image-53eb8ceac0b2498bccb772ef8e42b383.png";